import { useSelector } from "react-redux";

import { RootState } from "redux/store";

const useCalculateVat = () => {
	const organizationDetails = useSelector(
		(state: RootState) => state.authState.organizationDetails
	);

	const getVatAmount = (subTotal: number, isIncludeVat = true) => {
		return (
			subTotal *
			(isIncludeVat &&
			organizationDetails.isVatRegistered &&
			organizationDetails.vatPercentage
				? organizationDetails.vatPercentage / 100
				: 0)
		);
	};

	return { getVatAmount };
};

export default useCalculateVat;
